import React from "react"
import Nav from "./nav"
import secure from "../../../images/secure.svg"

const CompanyRegistrationWrapper = ({
  children,
  isLastStep,
  goToPreviousStep,
  canGoBack,
  actionLabel,
  currentStep,
  wizard,
  status,
}) => {
  // window.scrollTo(0, 0);
  return (
    <>
      <Nav currentStep={currentStep} wizard={wizard} />
      <div className="p-lg-5 p-4">
        {children}

        {status && (
          <p className="text-center mb-1 sparkle-bright-orange">
            {status.message}
          </p>
        )}
        <div className="row pt-5">
          <div className="col-lg-4 offset-lg-4 my-3">
            <button
              type="button"
              onClick={goToPreviousStep}
              disabled={!canGoBack}
              className={
                !canGoBack
                  ? "d-none"
                  : "btn sparkle--button__green_outline px-5 btn-block"
              }
            >
              Previous
            </button>
          </div>

          <div className="col-lg-4 my-3">
            <button
              type="submit"
              // onClick={window.scrollTo(0, 0)}
              className="btn sparkle--button__green sparkle--button__shadow px-5 btn-block w-100"
            >
              {actionLabel || (isLastStep ? "Submit" : "Next step")}
            </button>
          </div>
        </div>

       
      </div>
    </>
  )
}

export default CompanyRegistrationWrapper
